export const config = {
  "stripe_key": "pk_test_51IxlRJF32pO4iyiVpul6VTFptVNO3lacnvc3Z5i2JmzQDwtMQoJkbdD24qF12Ac6rDBQzpkfA6QPd90kORQjaEfz00f6fK8Jny",
  "maxFreeCharacters": 5000,
  "maxPremiumCharacters": 3000,
  "maxCharacterFreeErrorMessage": "Your text is over 5000 characters! Free tier is limited to 5000 characters for conversion from Text to Speech per day. Delete text to decrease the character count or buy a character pack to add more characters.",
  "maxCharacterPremiumErrorMessage": "Your text length is greater than the Neural Voice characters you have left on your account! Buy a character pack to add more characters.",
  "audioConvertUrl": "https://us-central1-audiobook-310902.cloudfunctions.net/audiobookApi/audio",
  "pdfParseUrl": "https://us-central1-audiobook-310902.cloudfunctions.net/pdfParser/pdftext",
  "getTextFromFileUrl": "https://getfiletext-2ev2dqebqa-uc.a.run.app/filetext",
  "getPremiumVoiceUrl": "https://us-central1-audiobook-310902.cloudfunctions.net/PremiumVoiceGetAudio/audio",
  "products": {
    "membership": {
      "monthly": "price_1IxmAWF32pO4iyiVxfpiFrCV",
      "yearly": "price_1IxmB3F32pO4iyiVbeheIFT3"
    },
    "characterPack": {
      "50000": "price_1J9QS7F32pO4iyiVssn2DbtG",
      "100000": "price_1JA3SFF32pO4iyiVrlWwM4vi",
      "250000": "price_1JA3XoF32pO4iyiVar3j7xZD",
      "500000": "price_1JA3YOF32pO4iyiV4xYIK8UN",
      "1000000": "price_1JA3YpF32pO4iyiVnilEp1Gf"
    }
  },
  "textByLanguage": {
    "en": {
      "cancel": "Cancel",
      "ok": "Ok",
      "accept": "Accept",
      "serverError": "There was an error on the server. Please try again later.",
      "premiumTextTooLarge": "This text will take some time to convert, we will email you the download link when the conversion is complete.",
      "jobId": "Is your job id. A confirmation email has been emailed to you.",
      "priceBlockPoint.1": "Free Neural Voice credits.",
      "priceBlockPoint.2": "Access to over 200 voices in 40 languages",
      "priceBlockPoint.3": "Ability to adjust pitch and speaking rate",
      "priceBlockPoint.4": "Ability to choose between .wav or .mp3 audio format",
      "buyText": "Buy",
      "enterpriseSolution": "Enterprise Solution",
      "maxCharacterFreeErrorMessage": "Your text is over 5000 characters! Free tier is limited to 5000 characters for conversion from Text to Speech per day. Delete text to decrease the character count or buy a character pack to add more characters.",
      "maxCharacterPremiumErrorMessage": "Your text length is greater than the Neural Voice characters you have left on your account! Buy a character pack to add more characters.",
      "pleaseBePatient": "Please be patient, this may take up to several minutes",
      "header.audioGenerator": "AUDIO GENERATOR",
      "header.pricing": "PRICING",
      "header.faq": "FAQ",
      "header.login": "LOGIN",
      "header.title": "Free Text To Speech",
      "header.summary": "Convert text from any file to natural sounding voice using the revolutionary Neural Voice Technology",
      "header.summary2": "Try out standard and neural voice technology voices!",
      "header.neuralVoiceTechnology": "Neural Voice Technology",
      "generator.step1": "Upload file or enter text below:",
      "generator.step1.supportedFileExtensions": "Supported File Extensions: ",
      "generator.upload": "UPLOAD",
      "generator.step2": "Select Voice Language",
      "generator.step2.basic": "BASIC",
      "generator.step2.neuralVoice": "NEURAL VOICE",
      "generator.step2.mp3Format": "MP3 Format",
      "generator.step2.mp3FormatDescription": "(great quality, minimum size)",
      "generator.step2.wavFormat": "WAV Format",
      "generator.step2.wavFormatDescription": "(best quality, largest size)",
      "generator.step2.speakingRate": "Speaking Rate",
      "generator.step2.pitch": "Pitch",
      "generator.step3": "Create Free Audio!",
      "generator.step3.createAudioButton": "CREATE AUDIO",
      "freeCharactersLeft": "Free Voice Characters Left",
      "neuralVoiceCharactersLeft": "Neural Voice Characters Left",
      "currentTextLength": "Current Text Length",
      "defaultEditorText": "Audio Anything is a free text to speech software that uses artificial intelligence and machine learning to generate authentic human voices. It support text to speech in over 200 voices and over 40 languages!",
      "audioPlayer.free": "Free",
      "audioPlayer.neuralVoice": "Neural Voice",
      "neuralVoiceCharacters": "Neural Voice Characters",
      "characterPack.title": "Character Packs",
      "characterPack.summary": "Choose a monthly subscription or pay as you go with character packs",
      "neuralCharacterDescription1": "Neural Voice credits.",
      "neuralCharacterDescription2": "Access to over 200 voices in 40 languages",
      "neuralCharacterDescription3": "Ability to adjust pitch and speaking rate",
      "neuralCharacterDescription4": "Ability to choose between .wav or .mp3 audio format",
      "characterPackButtonText": "BUY",
      "enterpriseSolutionContactUs": "Contact us to discuss custom solutions for your business",
      "enterpriseButtonText": "CONTACT US",
      "frequentlyAskedQuestions": "Frequently Asked Questions",
      "faqAccordionQ1": "What are the benefits of a premium membership?",
      "faqAccordionA1": "Access to over 200 natural sounding voices in over 40 languages!: Ability to save,view, and download previously converted audio files!: Access to voice speed and pitch tuning!: Free character pack which replenishes every month!",
      "faqAccordionQ2": "What is a Neural Voice?",
      "faqAccordionA2": "Neural text-to-speech (NTTS) model uses machine learning technologies to generate synthesized speech from text that sounds like a human voice. Using neural networks, it is now possible to produce very natural-sounding speech that includes different accents.",
      "faqAccordionQ3": "More Questions?",
      "faqAccordionA3": "Get in touch with us support@audioanything.com"
    }
  }
}